import Registry from '../registry'
import React from 'react'
import ColorPicker from '../components/fields/ColorPicker'

const color = {
  name: 'Color',
  group: 'Content',
  schema: part => {
    return {
      type: 'string',
      component: locals => {
        return <ColorPicker onChange={locals.onChange} value={locals.value} />
      }
    }
  }
}

Registry.register('color', color)

export default color



// WEBPACK FOOTER //
// ./app/parts/color.js